interface PersonConfig {
  id: string
  created_by: string
  uriId: string
  account_id: string
  roles?: object[]
  phones: object[]
  first_name: string
  last_name: string
  fullName: string
  email?: string
  emails?: any[]
  profile?: string[]
  identification_number?: string
  identification_type?: string
  ibutton?: string
}

//Se quita la propiedad "readonly" de "class Thing" para poder modificar sus valores dinamicamente mediante WAMP//

class Person {
  public id: string
  public created_by: string
  public uriId: string
  public account_id: string
  public roles?: object[]
  public first_name: string
  public last_name: string
  public phones: object[]
  public fullName: string
  public email?: string
  public emails?: any[]
  public profile?: string[]
  public identification_number?: string
  public identification_type?: string
  public ibutton?: string

  constructor(configuration: PersonConfig) {
    this.id = configuration.id
    this.created_by = configuration.created_by
    this.uriId = configuration.uriId
    this.account_id = configuration.account_id
    this.roles = configuration.roles
    this.first_name = configuration.first_name
    this.last_name = configuration.last_name
    this.phones = configuration.phones
    this.fullName = configuration.fullName
    this.email = configuration.email
    this.emails = configuration.emails
    this.profile = configuration.profile
    this.identification_number = configuration.identification_number
    this.identification_type = configuration.identification_type
    this.ibutton = configuration.ibutton
  }
}

export { Person }
